
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDoc"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sub_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dm_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_urls"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"purchase_urls"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contract_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"private"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discontinued"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"intro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"info_insure_year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"info_payment_year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"info_payment_method"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"info_require_age"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"info_require_occ"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"info_require_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fee_discount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"info_require_other"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_additional"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"channel_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attribute_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"loading"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"loading_rate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ticket_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matched_state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matched_target"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":487}};
    doc.loc.source = {"body":"fragment ProductFull on ProductDoc {\n  _id\n  company_id\n  title\n  sub_title\n  code\n  dm_url\n  product_urls\n  purchase_urls\n  contract_ids\n  currency_ids\n  private\n  discontinued\n  intro\n  info_insure_year\n  info_payment_year\n  info_payment_method\n  info_require_age\n  info_require_occ\n  info_require_amount\n  fee_discount\n  info_require_other\n  category_ids\n  is_additional\n  channel_ids\n  attribute_ids\n  loading\n  loading_rate\n  ticket_id\n  uploader\n  matched_state\n  matched_target\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProductFull"] = oneQuery(doc, "ProductFull");
        
